import React from "react";

export default function SvgComponent() {
  return (
    <svg viewBox="0 0 145 145" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h145v145H0z" fill="#ad1925" />
      <path
        d="M109.375 115.394c-4.965-9.396-36.875-15.292-36.875-15.292s-31.91 5.896-36.875 15.292C31.957 128.433 28.889 145 28.889 145h87.222s-2.072-17.764-6.736-29.606z"
        fill="#f1c9a5"
      />
      <path
        d="M72.5 100.102s31.91 5.896 36.875 15.292c4.664 11.842 6.736 29.606 6.736 29.606H72.5v-44.898z"
        fill="#e4b692"
      />
      <path d="M63.812 81h17.375v29.077H63.812z" fill="#f1c9a5" />
      <path d="M72.5 81h8.688v29.077H72.5z" fill="#e4b692" />
      <path
        d="M63.813 94.474c1.563 4.485 7.869 7.056 12.5 7.056 1.676 0 3.305-.28 4.875-.794V81H63.813v13.474z"
        fill="#ddac8c"
        opacity=".1"
      />
      <path
        d="M94.838 62.652c0-18.162-10.002-28.489-22.338-28.489S50.162 44.491 50.162 62.652c0 24.429 10.002 32.887 22.338 32.887s22.338-9.476 22.338-32.887z"
        fill="#f1c9a5"
      />
      <path
        d="M91.438 75.246c-4.049-.424-6.783-4.787-6.098-9.74.678-4.957 4.514-8.637 8.564-8.215 4.047.422 6.777 4.782 6.094 9.739-.68 4.958-4.512 8.635-8.56 8.216z"
        fill="#e4b692"
      />
      <path
        d="M45.16 67.031c-.684-4.957 2.047-9.317 6.092-9.739 4.053-.422 7.889 3.259 8.568 8.215.684 4.953-2.053 9.316-6.1 9.74-4.048.418-7.88-3.259-8.56-8.216z"
        fill="#f1c9a5"
      />
      <path
        d="M94.838 62.652c0-18.162-10.002-28.489-22.338-28.489v61.376c12.336 0 22.338-9.476 22.338-32.887z"
        fill="#e4b692"
      />
      <path
        d="M92.594 77.874c-1.201 3.378-3.234 7.44-6.908 7.44-4.59 0-7.875-3.731-13.141-3.731l-.043.002-.047-.002c-5.266 0-8.547 3.731-13.141 3.731-3.672 0-5.705-4.062-6.906-7.44l-1.039-6.508v7.788s1.744 9.171 5.094 11.387c2.728 2.424 11.637 6.576 15.992 6.576l.047-.002.043.002h.002c4.357 0 13.264-4.152 15.99-6.576 3.35-2.216 5.096-11.387 5.096-11.387v-7.788l-1.039 6.508z"
        fill="#303030"
      />
      <path
        d="M76.135 87.437s-.531-2.367-3.635-2.367c-2.836 0-3.635 2.367-3.635 2.367h7.27z"
        fill="#fff"
      />
      <path
        d="M86.063 44.711s-1.861 5.851-15.158 11.701-19.146 7.712-18.082 13.562c-5.714-10.433-3.59-39.224 18.613-39.224 17.418 0 16.753 10.238 14.627 13.961z"
        fill="#303030"
      />
      <path
        d="M94.713 59.204s-7.721-13.562-13.172-14.226c2.395-7.845 5.6-7.313 5.6-7.313s8.65 1.588 7.572 21.539z"
        fill="#303030"
      />
      <path
        d="M109.375 115.394c-2.9-5.487-14.98-9.777-24.535-12.399.076-1.333-2.316 6.524-2.316 6.524l-9.707 21.768-9.08-20.298-3.576-7.994c-9.555 2.622-21.635 6.912-24.535 12.399C31.957 128.433 28.889 145 28.889 145h87.222s-2.072-17.764-6.736-29.606z"
        fill="#1f3a4d"
      />
    </svg>
  );
}
